<script>
import { interactionMixin } from "src/modules/interactions_module.js";
import { vodafoneLabContactMixin } from "../../modules/vodafone_lab_mixins_module.js"
import { sendFandomAnalyticsEvent } from "src/modules/fandom_analytics_module.js";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";

export default {
  mixins: [interactionMixin, fandomBasicMixin, vodafoneLabContactMixin],
  props: {
    // Placed temporary as a props, maybe it is better to place it in the globalState
    isIframe: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isContentVisibleToUser: Fandom.isContentVisibleToUser,
    trackContactClick(event) {
      const target = $(event.currentTarget);
      const href = target.attr("href");
      if (this.mainContent.parent_names.includes('target-soho') || this.mainContent.parent_names.includes('target-sme')) {
        sendFandomAnalyticsEvent("Interazione", "Click", "Contatta un Esperto");
      } else {
        sendFandomAnalyticsEvent("Interazione", "Click", "Contatta Team Sales");
      }
      if (href == "javascript:void(0)") {
        return false;
      }

      if (target.attr("target") == "_blank") {
        window.open(href, '_blank');
      } else {
        window.location.href = href;
      }
      return false;
    },
    mayUpdateFavouriteInteraction() {
      VodafoneLab.addDigitalDataEvent("content_save", "tools", `:Save:${this.containerContent.id}`);
      if (Fandom.isUserRegistered()) {
        this.updateFavouriteInteraction(this.containerContent, this.content.favourite, this.content.favourite.interaction)
      } else {
        Fandom.emit('toggle-registration-modal');
      }
    }
  },
  computed: {
    columnClasses() {
      const columnWidth = Fandom.exists(this.content.width) ? this.content.width : Fandom.retrieveFromGlobalState("one_col_text_width", 7);
      return [
        `col-lg-${columnWidth}`
      ];
    }
  }
};
</script>

<template>
  <div stripe-share-component>
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div :class="columnClasses" class="d-flex justify-content-center align-items-center">
          <div v-if="category" class="category small d-flex px-3 py-1 justify-content-center align-items-center">
            {{category}}
          </div>
          <div class="d-flex align-items-center justify-content-end flex-grow-1 pr-md-5 pr-2">
            <span class="d-none d-md-block">{{ft("globals.share_on")}}</span>
            <modal-share :content="content" :opt-container-content="containerContent" :is-iframe="isIframe"></modal-share>
          </div>
          <div class="d-flex align-items-center" v-if="content.favourite">
            <span class="d-none d-md-inline" v-if="!isFavourite(containerContent, content.favourite.interaction)">{{ft('globals.save')}}</span>
            <span class="d-none d-md-inline" v-else>{{ft('globals.delete')}}</span>
            <i
              :class="isFavourite(containerContent, content.favourite.interaction) ? 'fas' : 'fal'"
              class="fa-bookmark ml-3 cursor-pointer fa-lg"
              @click="mayUpdateFavouriteInteraction(containerContent, content.favourite, content.favourite.interaction)"
            ></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

[stripe-share-component] {
  background-color: $gray-225;

  .container > .row {
    height: 3.5rem;
    font-size: 1.125rem;

    .category {
      color: $gray-900;
      border: 1px solid $gray-900;
    }
  }

  .fa-lg {
    @include font-size(1.125rem);
  }

  .fa-bookmark {
    color: $gray-600;
  }
}

</style>